var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaddingBottomXl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_298)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    transform: "translate(196 98) rotate(180)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 84,
    width: 70,
    height: 180,
    rx: 5,
    transform: "rotate(-90 8 84)",
    fill: "#007FFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 84,
    width: 70,
    height: 180,
    rx: 5,
    transform: "rotate(-90 8 84)",
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.646 76.3536C103.842 76.5488 104.158 76.5488 104.354 76.3536L107.536 73.1716C107.731 72.9763 107.731 72.6597 107.536 72.4645C107.34 72.2692 107.024 72.2692 106.828 72.4645L104 75.2929L101.172 72.4645C100.976 72.2692 100.66 72.2692 100.464 72.4645C100.269 72.6597 100.269 72.9763 100.464 73.1716L103.646 76.3536ZM104.354 45.6464C104.158 45.4512 103.842 45.4512 103.646 45.6464L100.464 48.8284C100.269 49.0237 100.269 49.3403 100.464 49.5355C100.66 49.7308 100.976 49.7308 101.172 49.5355L104 46.7071L106.828 49.5355C107.024 49.7308 107.34 49.7308 107.536 49.5355C107.731 49.3403 107.731 49.0237 107.536 48.8284L104.354 45.6464ZM104.5 76L104.5 46L103.5 46L103.5 76L104.5 76Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 38L8 19C8 16.2386 10.2386 14 13 14L183 14C185.761 14 188 16.2386 188 19L188 38L8 38Z",
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34715 17.0727C8.12271 17.6725 8 18.3219 8 19C8 18.3282 8.16358 17.6907 8.45685 17.1182L8.34715 17.0727ZM10.9753 14.1124L11.2531 14.7823C11.7969 14.5998 12.3855 14.5 13 14.5L15.0238 14.5L15.0238 13.5L13.5 13.5C13.3315 13.5 13.1647 13.5076 13 13.5224C12.2754 13.5877 11.5914 13.7935 10.9753 14.1124ZM19.0714 13.5L19.0714 14.5L23.119 14.5L23.119 13.5L19.0714 13.5ZM27.1667 13.5L27.1667 14.5L31.2143 14.5L31.2143 13.5L27.1667 13.5ZM35.2619 13.5L35.2619 14.5L39.3095 14.5L39.3095 13.5L35.2619 13.5ZM43.3571 13.5L43.3571 14.5L47.4048 14.5L47.4048 13.5L43.3571 13.5ZM51.4524 13.5L51.4524 14.5L55.5 14.5L55.5 13.5L51.4524 13.5ZM59.5476 13.5L59.5476 14.5L63.5952 14.5L63.5952 13.5L59.5476 13.5ZM67.6429 13.5L67.6429 14.5L71.6905 14.5L71.6905 13.5L67.6429 13.5ZM75.7381 13.5L75.7381 14.5L79.7857 14.5L79.7857 13.5L75.7381 13.5ZM83.8333 13.5L83.8333 14.5L87.8809 14.5L87.8809 13.5L83.8333 13.5ZM91.9286 13.5L91.9286 14.5L95.9762 14.5L95.9762 13.5L91.9286 13.5ZM100.024 13.5L100.024 14.5L104.071 14.5L104.071 13.5L100.024 13.5ZM108.119 13.5L108.119 14.5L112.167 14.5L112.167 13.5L108.119 13.5ZM116.214 13.5L116.214 14.5L120.262 14.5L120.262 13.5L116.214 13.5ZM124.31 13.5L124.31 14.5L128.357 14.5L128.357 13.5L124.31 13.5ZM132.405 13.5L132.405 14.5L136.452 14.5L136.452 13.5L132.405 13.5ZM140.5 13.5L140.5 14.5L144.548 14.5L144.548 13.5L140.5 13.5ZM148.595 13.5L148.595 14.5L152.643 14.5L152.643 13.5L148.595 13.5ZM156.691 13.5L156.691 14.5L160.738 14.5L160.738 13.5L156.691 13.5ZM164.786 13.5L164.786 14.5L168.833 14.5L168.833 13.5L164.786 13.5ZM172.881 13.5L172.881 14.5L176.929 14.5L176.929 13.5L172.881 13.5ZM180.976 13.5L180.976 14.5L183 14.5C183.614 14.5 184.203 14.5997 184.747 14.7823L185.025 14.1124C184.409 13.7935 183.725 13.5877 183 13.5224C182.835 13.5076 182.669 13.5 182.5 13.5L180.976 13.5ZM187.653 17.0727L187.543 17.1182C187.836 17.6907 188 18.3282 188 19C188 18.3219 187.877 17.6724 187.653 17.0727ZM8 37.5L8 38L8 38.5L9.95652 38.5L9.95652 37.5L8 37.5ZM13.8696 37.5L13.8696 38.5L17.7826 38.5L17.7826 37.5L13.8696 37.5ZM21.6957 37.5L21.6957 38.5L25.6087 38.5L25.6087 37.5L21.6957 37.5ZM29.5217 37.5L29.5217 38.5L33.4348 38.5L33.4348 37.5L29.5217 37.5ZM37.3478 37.5L37.3478 38.5L41.2609 38.5L41.2609 37.5L37.3478 37.5ZM45.1739 37.5L45.1739 38.5L49.087 38.5L49.087 37.5L45.1739 37.5ZM53 37.5L53 38.5L56.913 38.5L56.913 37.5L53 37.5ZM60.8261 37.5L60.8261 38.5L64.7391 38.5L64.7391 37.5L60.8261 37.5ZM68.6522 37.5L68.6522 38.5L72.5652 38.5L72.5652 37.5L68.6522 37.5ZM76.4783 37.5L76.4783 38.5L80.3913 38.5L80.3913 37.5L76.4783 37.5ZM84.3043 37.5L84.3043 38.5L88.2174 38.5L88.2174 37.5L84.3043 37.5ZM92.1304 37.5L92.1304 38.5L96.0435 38.5L96.0435 37.5L92.1304 37.5ZM99.9565 37.5L99.9565 38.5L103.87 38.5L103.87 37.5L99.9565 37.5ZM107.783 37.5L107.783 38.5L111.696 38.5L111.696 37.5L107.783 37.5ZM115.609 37.5L115.609 38.5L119.522 38.5L119.522 37.5L115.609 37.5ZM123.435 37.5L123.435 38.5L127.348 38.5L127.348 37.5L123.435 37.5ZM131.261 37.5L131.261 38.5L135.174 38.5L135.174 37.5L131.261 37.5ZM139.087 37.5L139.087 38.5L143 38.5L143 37.5L139.087 37.5ZM146.913 37.5L146.913 38.5L150.826 38.5L150.826 37.5L146.913 37.5ZM154.739 37.5L154.739 38.5L158.652 38.5L158.652 37.5L154.739 37.5ZM162.565 37.5L162.565 38.5L166.478 38.5L166.478 37.5L162.565 37.5ZM170.391 37.5L170.391 38.5L174.304 38.5L174.304 37.5L170.391 37.5ZM178.217 37.5L178.217 38.5L182.13 38.5L182.13 37.5L178.217 37.5ZM186.043 37.5L186.043 38.5L188 38.5L188 38L188 37.5L186.043 37.5Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 150,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 150)",
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 150,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 150)",
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 6,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 6)",
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 6,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 6)",
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white",
    transform: "translate(196 98) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddingBottomXl);
export default __webpack_public_path__ + "static/media/padding_bottom_xl.f3380ac82eb24f7ae1d9ee9637dead34.svg";
export { ForwardRef as ReactComponent };